export const SIGNALR_HUB = 'https://InPlaySignalR.crbets.co.za/inplayhub';
export const BETAPI = 'https://betapi.crbets.co.za/';

export const MATCH_TIMERS = {
    "Tennis": 10,
    "Rugby": 10,
    "Cricket": 8,
    "Basketball": 10,
    "Soccer": 10,
    "Default": 8,
    "Difference": 4
}
export const SPORTS_AVAILABLE = {
    "Football": "Football",
    "Tennis": "Tennis"
}
export const STATSCORE_WIDGET = false;
export const STATSCORE_CONFIG_ID = '63c7c7ebecd1603eb251ad86';